/**
 * English country/region display names for location search.
 * Prefers Intl (full list in modern browsers); falls back if unavailable.
 */
const FALLBACK_COUNTRY_NAMES = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Argentina",
  "Australia",
  "Austria",
  "Bahrain",
  "Bangladesh",
  "Belgium",
  "Brazil",
  "Bulgaria",
  "Cambodia",
  "Canada",
  "Chile",
  "China",
  "Colombia",
  "Croatia",
  "Czechia",
  "Denmark",
  "Egypt",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hong Kong SAR China",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Ireland",
  "Israel",
  "Italy",
  "Japan",
  "Jordan",
  "Kenya",
  "Kuwait",
  "Malaysia",
  "Maldives",
  "Mexico",
  "Morocco",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Norway",
  "Oman",
  "Pakistan",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Saudi Arabia",
  "Singapore",
  "South Africa",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "Thailand",
  "Türkiye",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Vietnam",
];

export function getCountryNames() {
  try {
    if (typeof Intl !== "undefined" && typeof Intl.supportedValuesOf === "function") {
      const codes = Intl.supportedValuesOf("region").filter((c) => /^[A-Z]{2}$/.test(c));
      const dn = new Intl.DisplayNames(["en"], { type: "region" });
      const names = codes.map((c) => dn.of(c)).filter(Boolean);
      return [...new Set(names)].sort((a, b) => a.localeCompare(b));
    }
  } catch {
    /* ignore */
  }
  return [...FALLBACK_COUNTRY_NAMES];
}

export const COUNTRIES = getCountryNames();

/** Pre-selected country on the home hero search; user can change anytime. */
export const DEFAULT_SEARCH_COUNTRY = "India";
